<div>
<div class="container-fluid">

  <!-- Barra di ricerca rapida + bottone ricerca avanzata -->
  <app-request-list-search-bar
    [initialKeyword]="kwSearch"
    [initialFilters]="lastDialogFilters"
    (searchResult)="onSearchResult($event)"
    (cleared)="onSearchCleared()"
    (searchError)="onSearchError($event)">
  </app-request-list-search-bar>

  <div style="overflow-x: auto;">

    <app-data-table-with-pagination
      [data]="dataSource"
      [columns]="columns"
      [displayedColumns]="displayedColumns"
      [actions]="actions"
      [totalRows]="totalRows"
      [pageInit]="pageInit"
      [currentPage]="currentPage"
      [clientSidePagination]="isClientSidePagination"
      (changePagination)="pageChanged($event)"
      (changeOrder)="updateDataBySortParams($event)"
      sortActive=""
    ></app-data-table-with-pagination>

  </div>
</div>

<ng-template #addressCell let-col="col" let-element="element">
  <span *ngIf="!(element.building == null)"><b>{{ element.building.streetName + ', ' +
                                                  (element.building.streetNumber !== null? element.building.streetNumber + ', ' : '') +
                                                  (element.building.zip !== null? element.building.zip + ', ': '') +
                                                  (element.building.city !== null? element.building.city + ', ': '') +
                                                  (element.building.country !== null? element.building.country: '')}}</b></span>
  <span *ngIf="(element.building == null)"><i class="material-icons icsave">warning</i></span>
</ng-template>
</div>